/* @ngInject */

export default ($parse, $rootScope) => {
  return {
    restrict: 'A',
    compile: function ($element, attrs) {
      var fn = $parse(attrs.stMenuClick, null, true);
      return function menuClick(scope, element) {
        element.on('click', function (event) {
          var callback = function () {
            fn(scope, {
              $event: event
            });
          };
          scope.$apply(callback);
        });
      };
    }
  };
};
